import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  active: {
    fontWeight: "700 !important" as any,
    color: `${theme.palette.secondary.main} !important`,
    backgroundColor: "#fff !important",
  },
  inactive: {
    fontWeight: 500,
    color: "rgba(255,255,255,.87)",
  },
}));
